<template>
  <div>

    <div class="container-xl">
      <div class="row">
        <div class="card">
          <div class="pen">
            <img class="pen1" src="../img/Shopping cart@2x.png" alt="" />
            <!-- <h2>购买隐形保持器</h2> -->
          </div>
          <div class="Payinto">
            <img src="../img/steps22.png" alt="" />
          </div>
          <div class="Payinto1">
            <h4>付款成功</h4>
            <p>我们已成功收到您的订单!</p>
            <p>请去邮箱查询订单号</p>
          </div>
          <router-link to="/"
            ><button class="Payinto2">返回首页</button></router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  metaInfo:{
    link:[{
      rel:'canonical',
      href:'https://mybeame.com/zh-hk/payinto'
    },{
      rel:'alternate',
      href:'https://mybeame.com/zh-hk/payinto',
      hrefLang:'x-default'
    }
    ]
  },

};
</script>
<style scoped>
.row {
  text-align: center;
}
.card {
  width: 50%;
  margin: auto;
  margin-top: 50px;
  margin-bottom: 50px;
  border-radius: 12px 60px 12px 12px;
  box-shadow: 0px 0px 20px 0px rgba(42, 59, 77, 0.2);
}
.pen1 {
  width: 50px;
  height: 50px;
}
.pen {
  margin-top: 100px;
}
.pen > h2 {
  font-size: 36px;
  font-weight: 700;
}
.Payinto {
  margin-top: 100px;
}
.Payinto1 > h4 {
  font-size: 24px;
  margin-top: 20px;
  margin-bottom: 5px;
}
.Payinto2 {
  width: 50%;
  height: 60px;
  font-size: 18px;
  font-weight: 700;
  border: none;
  text-align: center;
  color: #323e48 !important;
  margin-top: 60px;
  margin-bottom: 50px;
  background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
  border-radius: 0px 10px 0px 0px;
  box-shadow: 0px 0px 6px 0px rgba(42, 59, 77, 0.2);
}

@media all and (max-width: 570px) {
  .card {
    width: 90%;
  }
  .Payinto2 {
    width: 80%;
    height: 50px;
  }
  .pen > h2 {
    font-size: 27px;
  }
  .Payinto {
    margin-top: 50px;
  }
}
</style>